import { render } from "./MenuControl.vue?vue&type=template&id=d0035f5e"
import script from "./MenuControl.vue?vue&type=script&lang=js"
export * from "./MenuControl.vue?vue&type=script&lang=js"

import "./MenuControl.vue?vue&type=style&index=0&id=d0035f5e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__